import { Box, useTheme, CircularProgress, Paper } from '@mui/material'
import { DataGrid, GridToolbar, gridClasses } from '@mui/x-data-grid'
import { tokens } from '../../theme'
import Headers from '../../components/Headers'
import { useMessageStore } from '../../Utils/Store'
import { useEffect, useState } from 'react'
import { useLoginStore } from '../../Utils/Store'

const Inbox = () => {
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)
  const messageData = useMessageStore((state) => state.messageData)
  const getInbox = useMessageStore((state) => state.getInbox)
  const [loading, setLoading] = useState(false)
  const [newMessData, setNewMessData] = useState([])

  const isLogin = useLoginStore((state) => state.isLogin)

  useEffect(() => {
    getInbox()
  }, [])

  useEffect(() => {
    setLoading(true)

    if (isLogin && messageData) {
      let processedMessages

      if (
        isLogin?.access_level === 'Admin' ||
        isLogin?.access_level === 'Manager'
      ) {
        processedMessages = messageData
      } else if (isLogin?.access_level === 'User') {
        const loggedInUsername = isLogin?.username
        processedMessages = messageData.filter((message) => {
          return message.user.username === loggedInUsername
        })
      }

      // Sort messages by date (latest first)
      if (processedMessages) {
        const sortedMessages = [...processedMessages].sort((a, b) => {
          return new Date(b.date) - new Date(a.date)
        })
        setNewMessData(sortedMessages)
      }
    }

    setLoading(false)
  }, [messageData, isLogin])

  function getUserName(params) {
    if (!params || !params.row) return '';
    const user = params.row.user
    return user ? user.username || '' : ''
  }

  const columns = [
    {
      field: 'phone_number',
      headerName: 'Phone number',
      flex: 1,
      cellClassName: 'name-column--cell',
    },
    {
      field: 'message',
      headerName: 'Message',
      flex: 1,
    },
    {
      field: 'username',
      headerName: 'Username',
      flex: 1,
      valueGetter: getUserName,
    },
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
    },
  ]
  return (
    <Box m="20px">
      <Paper
        elevation={0}
        sx={{ borderRadius: '10px', background: colors.primary[400] }}
      >
        <Headers title="Messages" />
      </Paper>
      {loading ? (
        <CircularProgress />
      ) : (
        <Paper
          elevation={0}
          sx={{ borderRadius: '10px', background: colors.primary[400] }}
        >
          <Box
            m="10px 0 0 0"
            height="70vh"
            sx={{
              '& .MuiDataGrid-root': {
                border: 'none',
              },
              '& .MuiDataGrid-cell': {
                borderBottom: 'none',
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word',
                maxHeight: 'none',
                fontSize: '14px',
              },
              '& .name-column--cell': {
                color: colors.greenAccent[300],
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: colors.blueAccent[700],
                borderBottom: 'none',
                fontSize: '16px',
              },
              '& .MuiDataGrid-virtualScroller': {
                backgroundColor: colors.primary[400],
              },
              '& .MuiDataGrid-footerContainer': {
                borderTop: 'none',
                backgroundColor: colors.blueAccent[700],
              },
              '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
                color: `${colors.grey[100]} !important`,
              },
            }}
          >
            <DataGrid
              rows={newMessData}
              columns={columns}
              components={{ Toolbar: GridToolbar }}
              getRowHeight={() => 'auto'}
              sx={{
                [`& .${gridClasses.cell}`]: {
                  py: 1,
                },
              }}
            />
          </Box>
        </Paper>
      )}
    </Box>
  )
}

export default Inbox
